/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { logger as log } from '@common/logger';
import {
  AppServiceMachineType,
  AppServiceRequestProcessor,
} from '@services/state-machine/index';
import { Client, Provider, cacheExchange, fetchExchange } from 'urql';
import { Graphql } from '@common/graphql';
import { Sttp } from '@common/sttp';
import { vappContainer } from '@/application';
import { apiConfig } from '@pages/AnalyticsPage/config/api.config';
import config from '@pages/AnalyticsPage/config/analyticsWidget.config.json';
import { GET_DASHBOARD_ANALYTICS_QUERY } from '@pages/AnalyticsPage/apis/graphql';
import { AnalyticsResultFormatterMessage } from '../../messages/analytics-result-formatter.message';
import { ANALYTICS_RESULT_FORMATTER_CONFIG } from '../../machines/analytics-result-formatter/config';
import { AppNavigatorService } from '@/AppNavigator';
import { StorageModule } from '@vlinder-web/storage-module-react';
import jwt_decode from 'jwt-decode';

// const getWhoamiSrv = () => {
//   return vappContainer.get<AppNavigatorService>(AppNavigatorService.displayName);
// };

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export interface IAnalyticsPluginMethods extends IPluginMethodMap {
  getAnalytics(args?: any): Promise<any>;
}

export class AnalyticsPlugin
  extends AppServiceRequestProcessor
  implements IAgentPlugin
{
  readonly methods: IAnalyticsPluginMethods;

  constructor() {
    super();
    this.methods = {
      getAnalytics: this.getAnalytics.bind(this),
    };
  }

  async getAnalytics(args?: any) {
    return await this.getProps(args);
  }
  //Graphql Query example
  async getProps(args?: any) {
    try {
      let gql = Graphql.withBaseUrl(apiConfig.gql.url);
      // const token = getToken();
      const storageSrv = StorageModule.getInstance();
      const token = loginSrv()?.getToken();
      if (token) {
        gql = gql.withHeaders({
          authentication: token,
        });
      }
      const client = gql.getClient();
      const res = await client
        .query(GET_DASHBOARD_ANALYTICS_QUERY, {})
        .toPromise();
      console.log('res data', res);
      if (res?.data?.getDashBoardAnalytics) {
        const message = new AnalyticsResultFormatterMessage({
          raw: res?.data?.getDashBoardAnalytics,
          template: { ...(config || {}) },
        });
        console.log('res ->', res?.data?.getDashBoardAnalytics);
        this.startSyncProcessing({
          machineConfig: {
            ...ANALYTICS_RESULT_FORMATTER_CONFIG,
            data: {
              message: message,
            },
          },
          machineType: AppServiceMachineType.DASHBOARD_ANALYTICS_FORMATTER,
        });

        return this._getResult(
          res?.data?.getDashBoardAnalytics,
          message?.template
        );
      }
      // log.log('result of capsules=', res?.data?.capsules);
    } catch (err: any) {
      log.error('error in capsules=', err?.message);
      throw err;
    }
  }

  private _getResult(data: any, template: any) {
    const _temp = template?.layout[0]?.colProps;
    const _template = template;
    if (
      !Array.isArray(data?.discountStats) ||
      data?.discountStats === null ||
      (Array.isArray(data?.discountStats) && data?.discountStats?.length === 0)
    ) {
      _temp?.filter((ele: any) => {
        return (
          ele.key !== 'totalGrantSum' ||
          ele.key !== 'consumedGrant' ||
          ele.key !== 'consumedPolicies'
        );
      });
    }
    _template.layout[0].colProps = _temp;

    return _template;
  }
}
